import { CurrentTournamentState } from './interfaces';
import { CurrentTournamentStoreStatus } from './enum';

export const initialState: CurrentTournamentState = {
  entity: {},
  status: {
    [CurrentTournamentStoreStatus.Loading]: [],
    [CurrentTournamentStoreStatus.Canceling]: [],
    [CurrentTournamentStoreStatus.Joining]: [],
    [CurrentTournamentStoreStatus.UpdatingInvitationStatus]: [],
    [CurrentTournamentStoreStatus.ViewingAnimation]: [],
    [CurrentTournamentStoreStatus.Withdrawing]: [],
    [CurrentTournamentStoreStatus.Disqualification]: [],
    [CurrentTournamentStoreStatus.UpdatingMatchGameResults]: [],
    [CurrentTournamentStoreStatus.UpdatingSpectatorStatus]: [],
    [CurrentTournamentStoreStatus.UpdatingAssets]: [],
    [CurrentTournamentStoreStatus.RunBracketMatch]: [],
    [CurrentTournamentStoreStatus.UpdatingTrackedBy]: [],
  },
};
